import { formatCurrency, toUnitCharacter } from "@sa-nu/shared-utils/price";

import { ClassAdditionalFeeIntegrationNote } from "./class-additional-fee-integration-note";
import { DescriptionHeader } from "./description-header";

export type DescriptionForLargeAccommodationMessages = {
  heading: string;
  feePerNight: (formattedFee: string) => string;
  noAdditionalFee: string;
  dynamicPricingNote: string;
  unitCharacter: string;
};

const JA_MESSAGES: DescriptionForLargeAccommodationMessages = {
  heading: "こちらの施設は LARGE サイズです",
  feePerNight: (formattedFee) =>
    `1泊あたり ${formattedFee}（税込）の追加料金がかかります。`,
  noAdditionalFee: "追加料金はかかりません。",
  dynamicPricingNote:
    "※ ただし、「お部屋・日程による変動料金」にはLARGEサイズの追加料金が含まれています",
  unitCharacter: "円",
};

/**
 * ラージサイズの宿泊施設の説明
 *
 * @param ruleRevision2027AppliesFrom 2027年度改定のルールが適用される最初の宿泊日。指定するとクラス追加料金への統合の注記を出す
 */
export function DescriptionForLargeAccommodation({
  additionalFee,
  hasDynamicPricing = false,
  ruleRevision2027AppliesFrom = null,
  messages = JA_MESSAGES,
}: {
  additionalFee: number;
  hasDynamicPricing?: boolean;
  ruleRevision2027AppliesFrom?: string | null;
  messages?: DescriptionForLargeAccommodationMessages;
}) {
  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader iconSrc="/i/icon_large.svg" iconAlt="LARGE">
        {messages.heading}
      </DescriptionHeader>
      <div className="text-xs md:text-sm">
        {additionalFee > 0
          ? messages.feePerNight(
              formatCurrency(additionalFee, {
                unitCharacter: toUnitCharacter(messages.unitCharacter),
              }),
            )
          : messages.noAdditionalFee}
        {hasDynamicPricing && (
          <>
            <br />
            <span className="text-skogecha-60">
              {messages.dynamicPricingNote}
            </span>
          </>
        )}
        {ruleRevision2027AppliesFrom !== null && (
          <ClassAdditionalFeeIntegrationNote
            appliesFrom={ruleRevision2027AppliesFrom}
          />
        )}
      </div>
    </div>
  );
}
